import React from 'react'

const MiniTeamStandingsRank = ({rank, standing_team_name, standing_mini_team_id}) => {
    
    //console.log('rank value passed ::', rank);
    //console.log('standing team name value passed ::', standing_team_name);
    //console.log('mini_team_id value passed ::', standing_mini_team_id);

    return(
    <td className="standings-rank">
      <div className="rank">#{ rank }</div>
    </td>
    )

}
  

export default MiniTeamStandingsRank